import { TableCell } from '@mui/material';
import { Observer } from 'mobx-react';
import * as React from 'react';

import { withConfirmModal } from 'hocs';

import { SettingsMenu } from 'components/SettingsMenu';

import { t } from 'utils';

import { onDeleteTask } from '../../actions';

import { DeleteAction } from '.';
import { Trigger } from './Trigger';
import { styles } from './styles';

type OriginalProps = {
  taskId: number;
};

type Props = OriginalProps & HOC.withConfirmModal<'deleteConfirm'>;

let ActionCellComp = ({ taskId, deleteConfirm }: Props) => {
  const classes = styles();

  const onDelete = () => {
    deleteConfirm.open(() => {
      onDeleteTask(taskId);
    });
  };

  const onEdit = () => {};

  return (
    <Observer>
      {() => {
        return (
          <TableCell className={classes.root}>
            <SettingsMenu
              id={taskId}
              Trigger={Trigger}
              additionalMenuProps={{
                anchorOrigin: {
                  vertical: 'top',
                  horizontal: 'right',
                },
                transformOrigin: {
                  vertical: 'bottom',
                  horizontal: 'left',
                },
              }}
            >
              <DeleteAction onClick={onDelete}>{t.staticAsString('supportTaskManager.list.table.deleteTask')}</DeleteAction>
            </SettingsMenu>
          </TableCell>
        );
      }}
    </Observer>
  );
};
const deleteDecorator = withConfirmModal('deleteConfirm', {
  i18Title: 'supportTaskManager.list.table.deleteTaskTitle',
  i18Body: 'supportTaskManager.list.table.deleteTaskBody',
  type: 'confirm',
});

export const ActionCell = deleteDecorator(ActionCellComp) as unknown as React.ComponentType<OriginalProps>;
